import * as React from 'react';
import { Theme, Typography } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';
import useShopFormat from 'hooks/useShopFormat';
import { isTimeBeforeTimeNow } from 'services/utils/dateCalculations';

interface OwnProps {
	productsReturned: boolean;
	shopperStartDate: string | null;
	shopperEndDate: string | null;
}

type Props = OwnProps & WithStyles<typeof styles>;

export const ReturnTime = ({
	classes,
	productsReturned,
	shopperStartDate,
	shopperEndDate,
}: Props) => {
	const { localFormat } = useShopFormat();

	if (!shopperStartDate || !shopperEndDate) {
		return null;
	}

	const shopperReturningOrStartingLate = !productsReturned && !!isTimeBeforeTimeNow(shopperEndDate);

	return (
		<Grid container spacing={0} direction={'column'} className={classes.returnTimeContainer}>
			<Grid item>
				<div>
					<Typography
						id="start-date"
						variant="body2"
						color={shopperReturningOrStartingLate ? 'error' : 'initial'}
					>
						{localFormat(shopperStartDate, 'ddd D.M., HH:mm') + ' -'}
					</Typography>
				</div>
			</Grid>
			<Grid item>
				<div>
					<Typography
						id="end-date"
						variant="body2"
						color={shopperReturningOrStartingLate ? 'error' : 'initial'}
					>
						{localFormat(shopperEndDate, 'ddd D.M., HH:mm')}
					</Typography>
				</div>
			</Grid>
		</Grid>
	);
};

const styles = (theme: Theme) =>
	createStyles({
		returnTimeContainer: {
			marginRight: theme.spacing(3),
		},
	});

export default withStyles(styles)(ReturnTime);
